/* globals _gaq, UserJourneyDTO */

import jquery from 'jquery';
  
class UserJourney{
     
    constructor(UserJourneyDTO){
        this.__userJourneyDTO = UserJourneyDTO;
        this.__navTabs = jquery('.js-nav-tabs li');
        this.__shareFcbk = jquery('#js-share-fcbk');
        this.__shareTw = jquery('#js-share-tw');
        this.__shareGp = jquery('#js-share-gp');
        this.__featureCard = jquery('.js-feature-card');
        this._isDesktop = jquery(window).width() > 1024;
        this.__headerHeight = 56;
        this.__buttonReturnTop = jquery('.js-return-top');
        this.__menuItem = jquery('#js-menu .menu-item');
        this.__cards = jquery('.grid-card');
        this.__activeStage = 'stage_' + (window.location.search.slice(1).split('=')[1] ? window.location.search.slice(1).split('=')[1] : "1");
        this.__feedback = jquery('.js-feedback');
        this.__feedbackQuestion = jquery('.js-feedback-question');
        this.__feedbackAnswer = jquery('.js-feedback-answer');
        this.__linkStagePost = jquery('.js-link-stage-post');
        this.__buttonVerConsejosHome = jquery('.js-ver-consejos');
        this.__buttonChangeStageList = jquery('.js-stage-list');
        this.__linkCrearAlerta = jquery('.js-crear-alerta');
        this.__linkRegistroPost = jquery('#js-registro-post');
        this.__linkCrearAlertaPost = jquery('#js-crear-alerta-post');
        this.__linkGoogleFormFeedback = 'https://docs.google.com/forms/d/e/1FAIpQLScPE2YGFZyITDZ6SjO5AdFqSMmow9SZj4FSd_6ZMZhVAFxr3g/viewform?entry.449892897=';

        this.registerEvents();
        this._setActiveStage(this.__activeStage);
    }
  
    registerEvents(){
        // Show tabs
        this.__navTabs.click((event) => {
            const tab_id = jquery(event.currentTarget).attr('data-tab');

            jquery(event.currentTarget).siblings().removeClass('current');
            jquery("#" + tab_id).siblings().removeClass('current');

            jquery(event.currentTarget).addClass('current');
            jquery("#" + tab_id).addClass('current');
        });
        // Social
        this.__shareFcbk.click(() =>{
            let newLocation = document.location.href;
            newLocation = '//www.facebook.com/sharer.php?u=' + newLocation;
            window.open(newLocation);
        });
        this.__shareTw.click(() =>{
            let newLocation = document.location.href;
            newLocation = '//www.twitter.com/share?original_referer=' + newLocation;
            window.open(newLocation);
        });
        // Open and close feature card when clicked on card
        jquery('#js-feature-cards').find('.js-expander').click((event) =>{
            
            const thisFeatureCard = jquery(event.currentTarget).closest('.js-feature-card');
        
            if (thisFeatureCard.hasClass('js-is-collapsed')) {
                this.__featureCard.not(thisFeatureCard).removeClass('js-is-expanded').addClass('js-is-collapsed');
                thisFeatureCard.removeClass('js-is-collapsed').addClass('js-is-expanded');

                // Scroll top
                if(this._isDesktop){
                    jquery('html, body').animate({scrollTop: thisFeatureCard.offset().top-this.__headerHeight}, 400);
                }
                else{
                    jquery('html, body').animate({scrollTop: thisFeatureCard.offset().top-this.__headerHeight}, 0);
                }
            } 
            else {
                thisFeatureCard.removeClass('js-is-expanded').addClass('js-is-collapsed');
            }
        });
        // Close feature card when click on cross icon
        this.__featureCard.find('.js-collapser').click((event) =>{
            
            const thisFeatureCard = jquery(event.currentTarget).closest('.js-feature-card');
            thisFeatureCard.removeClass('js-is-expanded').addClass('js-is-collapsed');
        });
        // Open feature card tabs when clicked on card
        jquery('#js-feature-cards-tabs').find('.js-expander').click((event) =>{

            const thisFeatureCard = jquery(event.currentTarget).closest('.js-feature-card');

            if (thisFeatureCard.hasClass('js-is-collapsed')) {
                this.__featureCard.not(thisFeatureCard).removeClass('js-is-expanded').addClass('js-is-collapsed');
                thisFeatureCard.removeClass('js-is-collapsed').addClass('js-is-expanded');
               
                // Scroll top
                if(this._isDesktop){
                    jquery('html, body').animate({scrollTop: thisFeatureCard.offset().top-this.__headerHeight}, 400);
                }
                else{
                    jquery('html, body').animate({scrollTop: thisFeatureCard.offset().top-this.__headerHeight}, 0);
                }
            }
        });

        // Smooth Scrolling to internal links
        jquery('.js-scroll-link').click((event) =>{
            event.preventDefault();
            const thisCurrentHref = jquery(jquery(event.currentTarget).attr('href'));
            jquery('html, body').animate({
                scrollTop: thisCurrentHref.offset().top - this.__headerHeight
            },600);
        });
        // Smooth Scrolling to internal buttons
        jquery('.js-scroll-button').click((event) =>{
            event.preventDefault();
            const thisCurrentData = jquery(jquery(event.currentTarget).data('step'));
            jquery('html, body').animate({
                scrollTop: thisCurrentData.offset().top
            },600);
        });

        // Scroll to Top 
        jquery(window).scroll(() =>{
            if(this._isDesktop){
                if (jquery(window).scrollTop() >= this.__headerHeight) {
                    this.__buttonReturnTop.fadeIn(200);
                } else {
                    this.__buttonReturnTop.fadeOut(200);
                }
            }
        });
        this.__buttonReturnTop.click(() =>{
            jquery('body,html').animate({
                scrollTop : 0
            }, 600);
        });

        // Menu items
        this.__menuItem.click((event) =>{
            jquery(event.currentTarget).siblings().removeClass('active');
            jquery(event.currentTarget).addClass('active');
            this._filterStage(jquery(event.currentTarget)[0].id);
        });

        // Post feedback
        this.__feedback.click((event) =>{
            const currentAnswer = jquery(event.currentTarget).data('answer');
            _gaq.push(['_trackEvent', 'satisfaccion-post', 'click', currentAnswer]);

            this.__feedbackQuestion.hide();
            this.__feedbackAnswer.fadeIn(200);

            if(currentAnswer.indexOf('no') !== -1){
                window.open(this.__linkGoogleFormFeedback + this.__userJourneyDTO.postId);
            }
        });

        //Track events
        this.__linkStagePost.click(() =>{
            _gaq.push(['_trackEvent', 'navegacion-uj', 'click', 'etapa-post']);
        });
        this.__buttonVerConsejosHome.click(() =>{
            _gaq.push(['_trackEvent', 'navegacion-uj', 'click', 'consejos-home']);    
        });
        this.__buttonChangeStageList.click(() =>{
            _gaq.push(['_trackEvent', 'navegacion-uj', 'click', 'etapa-listado']);    
        });
        this.__linkCrearAlerta.click(() =>{
            _gaq.push(['_trackEvent', 'navegacion-uj', 'click', 'crear-alerta']);    
        });
        this.__linkRegistroPost.click(() =>{
            _gaq.push(['_trackEvent', 'navegacion-uj', 'click', 'link-registro']);    
        });
        this.__linkCrearAlertaPost.click(() =>{
            _gaq.push(['_trackEvent', 'navegacion-uj', 'click', 'link-alerta']);    
        });
    }
    _setActiveStage(stage) {
        jquery('#' + stage).addClass('active');
        this._filterStage(stage);
    }
    _filterStage(stage) {
        this.__cards.each(function () {
            const $elem = jquery(this);
            if (!$elem.hasClass(stage)) {
                $elem.hide();
            } else {
                $elem.fadeIn(300);
            }
        });
    }
}
  
/* jshint unused: false */
const userJourneyInstance = new UserJourney(UserJourneyDTO);